import { ZapierLogo } from "@zapier/design-system";
import styles from "./Watermark.module.css";

/** This is a hidden component. When you download the Canvas in usePrepareDownloadImage, we render this to the bottom of the Canvas.
 * Then we take a screenshot and remove the component.
 * */
export default function Watermark() {
  return (
    <div className={styles.watermark}>
      <div>Built on</div>
      <ZapierLogo
        height={13}
        variant="wordmark-horizontal-inverse"
        width={48}
      />
    </div>
  );
}
